import { render, staticRenderFns } from "./ClientLandingPageCustomizer.vue?vue&type=template&id=00b07872&scoped=true&"
import script from "./ClientLandingPageCustomizer.vue?vue&type=script&lang=js&"
export * from "./ClientLandingPageCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./ClientLandingPageCustomizer.vue?vue&type=style&index=0&id=00b07872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b07872",
  null
  
)

export default component.exports